<app-accordion>
<app-accordion-item
  id="SkuPrices"
  icon="credit-card"
  label="Preços"
  bodyClass="rounded border border-neutral-300 dark:border-neutral-700 p-3"
>
  @if (sku.skuPrices) {
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
    <div>
      <div>Preço de custo</div>
      <div class="font-medium">
        {{ sku.skuPrices.costPrice | currency : 'BRL' : 'symbol' }}
      </div>
    </div>

    <div>
      <div>Preço base</div>
      <div class="font-medium">
        {{ sku.skuPrices.basePrice | currency : 'BRL' : 'symbol' }}
      </div>
    </div>

    <div>
      <div>Preço de listagem</div>
      <div class="font-medium">
        {{ sku.skuPrices.listPrice | currency : 'BRL' : 'symbol' }}
      </div>
    </div>

    <div>
      <div>Markup</div>
      <div class="font-medium">{{ sku.skuPrices.markup }}</div>
    </div>
  </div>

  <table class="w-full text-sm mt-2">
    <thead class="bg-neutral-50 dark:bg-neutral-800">
      <tr>
        <th class="text-left p-2">Canal</th>
        <th class="text-left p-2">Preço</th>
        <th class="text-left p-2">Markup</th>
      </tr>
    </thead>
    <tbody>
      @for (row of (sku.skuPrices.fixedPrices ?? []); track row.tradePolicyId) {
      <tr class="border-t border-neutral-200 dark:border-neutral-700">
        <td class="p-2">{{ row.tradePolicyId }}</td>
        <td class="p-2 font-semibold">{{ row.value | currency : 'BRL' : 'symbol' }}</td>
        <td class="p-2">
          @if (row.value && sku.skuPrices.costPrice) {
          {{ -(1 - row.value / sku.skuPrices.costPrice) * 100 | number : '1.1-2' }} % }
        </td>
      </tr>
      } @empty {
      <tr class="border-t border-neutral-200 dark:border-neutral-700">
        <td colspan="3">
          <p class="my-2 text-center">Nenhum preço encontrado para este SKU.</p>
        </td>
      </tr>
      }
    </tbody>
  </table>
  } @else if (sku.skuPricesLoading) {
  <app-loading size="large" />
  } @else {
  <p>Produto não possui preços cadastrados.</p>
  }
</app-accordion-item>
</app-accordion>
